import { PlusOutlined } from '@ant-design/icons';
import { Col, DatePicker, DatePickerProps, Row, Select, Table, Tag } from "antd";
import { ContentHeader } from "../../components";
import Column from "antd/es/table/Column";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Links } from "../../helpers/Links";
import { Link } from "react-router-dom";
import { menuHelper } from "../../helpers/account";
import { layDsKhenThuongUngHo } from '../../services/luong';
import { formatVND, layKieuTinhUngHo, layLoaiUngHo } from '../../helpers/common';
import dayjs, { Dayjs } from 'dayjs';
import { DanhSachKhenThuongUngHoResponse } from '../../models/luong/Luong';

const optionsLoai = [
    { value: -1, label: "Tất cả loại" },
    { value: 0, label: "Giảm trừ thu nhập" },
    { value: 1, label: "Thu nhập bổ sung" }
];

const DanhSachKhenThuongUngHo = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [rawData, setRawData] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [loaiFilter, setLoaiFilter] = useState<number>(-1);
    const menu: any = menuHelper.checkMultiPermission([Links.Luong.KhenThuongUngHo, Links.Luong.ChiTietKhenThuongUngHo]);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(null);

    const layDuLieu = async (date: string) => {
        try {
            setIsLoading(true);
            var rs = await layDsKhenThuongUngHo(date);
            // Lọc bỏ Công đoàn phí (loaiUngHo = 2) vì đã có chức năng riêng
            var filtered = (rs || []).filter((v: DanhSachKhenThuongUngHoResponse) => v.loaiUngHo !== 2);
            setRawData(filtered.map((v: DanhSachKhenThuongUngHoResponse) => ({ ...v, key: v.id })));
            setIsLoading(false);
        }
        catch (err: any) {
            toast.error(err);
            setIsLoading(false);
        }
    }

    const dataTable = useMemo(() => {
        if (loaiFilter === -1 || loaiFilter === undefined || loaiFilter === null) {
            return rawData;
        }
        return rawData.filter((x) => x.loai === loaiFilter);
    }, [rawData, loaiFilter]);

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            layDuLieu(dateStr);
        } else {
            layDuLieu("");
        }
    }

    useEffect(() => {
        layDuLieu("");
    }, [])

    return (
        <section>
            <ContentHeader title="Danh sách phát sinh" />
            <Row className="mb-2" gutter={16}>
                <Col span="5">
                    <DatePicker changeOnBlur={true} value={ngayThang} style={{ width: "100%" }} placeholder="Tháng" picker="month" format={thangNamFormat} onChange={onChange} />
                </Col>
                <Col span="5">
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Chọn loại phát sinh"
                        value={loaiFilter}
                        onChange={(value) => setLoaiFilter(value)}
                        options={optionsLoai}
                    />
                </Col>
                <Col span="14">
                    {
                        menu[Links.Luong.ChiTietKhenThuongUngHo] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.Luong.ChiTietKhenThuongUngHo}><PlusOutlined rev="" />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Tháng" dataIndex="thoiGian" key="thoiGian" />
                            <Column title="Tên" dataIndex="ten" key="ten" />
                            <Column title="Loại phát sinh" dataIndex="loai" key="loai" render={(text: string) => layLoaiUngHo(text)} />
                            <Column title="Mức tính" dataIndex="loaiUngHo" key="loaiUngHo" render={(text: string) => layKieuTinhUngHo(text)} />
                            <Column title="Số lượng CBCNV" dataIndex="soLuongCBCNV" key="soLuongCBCNV" align="center" />
                            <Column title="Tổng số tiền" dataIndex="tongSoTien" key="tongSoTien" align="right" render={(value) => formatVND(value)} />
                            <Column title="Trạng thái" dataIndex="khoaDieuChinh" key="khoaDieuChinh" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="blue">Khởi tạo</Tag>); break;
                                    case 1: tag = (<Tag color="success">Đã xác nhận</Tag>); break;
                                }
                                return tag;
                            }} />
                            {
                                menu[Links.Luong.ChiTietKhenThuongUngHo] &&
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Luong.ChiTietKhenThuongUngHo + "?id=" + record.id}>Xem</Link>
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachKhenThuongUngHo;